$(function() {
    $('[data-ga-event]').each((i, el) => {
        const $el = $(el);
        $el.on('click', event => {
            const payload = $el.data('ga-event');
            gaEvent(payload);
        });
    });
});

export function gaEvent(event) {
    if (event && window.ga) {
        dataLayer.push(event);
    }
}
